





















import { defineComponent, ref } from '@nuxtjs/composition-api';
import { BaseButton } from '@shared/ui';

import LoginForm from '~/components/LoginForm.vue';
import SignupForm from '~/components/SignupForm.vue';

export default defineComponent({
  name: 'LoginSignUpForm',
  components: {
    BaseButton,
    SignupForm,
    LoginForm,
  },
  props: {
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    userFullName: {
      type: String,
      default: '',
    },
    isSignUp: {
      type: Boolean,
      default: false,
    },
    toggleSignUp: {
      type: Function,
      default: () => null,
    },
  },
  setup() {
    const isSignupSuccess = ref(false);

    const updateSignUpFormContent = () => {
      isSignupSuccess.value = true;
    };

    return {
      isSignupSuccess,
      updateSignUpFormContent,
    };
  },
});
